import React from 'react';
import logoSquare from 'assets/logo/logo-square.png';

const Preloader = () => {
  return (
    <div className='fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm transition-all duration-500'>
      <div className='relative flex flex-col items-center'>
        <div className='mb-4 flex h-14 w-14 items-center justify-center'>
          <img src={logoSquare} alt='Pulsalink Logo' className='h-12 w-12 object-contain' />
        </div>

        <div className='flex flex-col items-center space-y-3'>
          <h1 className='text-lg font-semibold text-gray-700'>Pulsalink</h1>

          <div className='flex items-center space-x-1.5'>
            <div className='h-2 w-2 animate-bounce rounded-full bg-primary shadow-sm [animation-delay:-0.3s]'></div>
            <div className='h-2 w-2 animate-bounce rounded-full bg-primary/80 shadow-sm [animation-delay:-0.15s]'></div>
            <div className='h-2 w-2 animate-bounce rounded-full bg-primary/60 shadow-sm'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
